module.exports = __webpack_public_path__ + "img/51_54.a9fcba11.png";